WiseMetering.Views.AddCompany = WiseMetering.Views.Modal.Save.extend({
    template: 'templates/companies/add',
    className: 'mbx-info text-left',
    form_prefix: 'company',
    title: () => i18next.t('modal.title.companies.add')
});
